import { ref } from 'vue'
import FieldOptionsService from '@/Network/Services/FieldOptionsService'
import { useErrorToast } from '@/composables/useErrorToast'

type Option = { label: string; value: string }

// Cache em nível de módulo: a aba e o modal de histórico ficam montados ao mesmo
// tempo, e a lista de grupos operacionais não muda durante a sessão.
const options = ref<Option[]>([])
let inFlight: Promise<void> | null = null

export const useOperationalGroups = () => {
  const { notifyError } = useErrorToast()

  const load = async () => {
    if (options.value.length > 0) return
    if (inFlight) return inFlight

    inFlight = (async () => {
      try {
        const service = new FieldOptionsService()
        const groups = await service.getOperationalGroups()
        options.value = groups.map((group) => ({ label: group.name, value: group.name }))
      } catch (error) {
        // Uma busca por vez (inFlight): consumidores montados juntos geram um único toast.
        notifyError(error, 'Não foi possível carregar os grupos operacionais.')
        options.value = []
      } finally {
        inFlight = null
      }
    })()

    return inFlight
  }

  return { options, load }
}
